import { all } from 'redux-saga/effects';

import verificationSaga from '../pages/ProfileVerification/sagas';
import profileDataSaga from '../pages/ProfileData/sagas';
import personalDetailsSaga from '../components/PersonalDetailsForm/sagas';

function* profileSaga() {
  yield all([verificationSaga(), profileDataSaga(), personalDetailsSaga()]);
}

export default profileSaga;
